import { Injectable } from '@angular/core';
import { Client, IMessage } from '@stomp/stompjs';
import * as SockJS from 'sockjs-client';
import { AppConfigService } from '../Configuration/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  constructor(private appConfig: AppConfigService){

  }

  public connect(): Client {
    const stompClient = new Client({
      // webSocketFactory: () => new SockJS('http://localhost:8081/socket'),
      // webSocketFactory: () => new SockJS('https://sse.mobitrix.net/socket'),
      webSocketFactory: () => new SockJS(this.appConfig.setting.communicationServerApi + 'socket'),
      reconnectDelay: 5000, // auto-reconnect after 5 seconds
      debug: (msg) => console.log(msg)
    });
    return stompClient;
  }

}
